/**
 * @generated SignedSource<<eef72bc32508a436fbc37129e882ffcc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LoginTextField_company$data = {
  readonly preferences: {
    readonly core: {
      readonly login: {
        readonly enableEmail: boolean | null | undefined;
        readonly enableEnrollment: boolean | null | undefined;
        readonly enableTaxID: boolean | null | undefined;
      };
    };
  };
  readonly " $fragmentType": "LoginTextField_company";
};
export type LoginTextField_company$key = {
  readonly " $data"?: LoginTextField_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"LoginTextField_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LoginTextField_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyCorePreferences",
          "kind": "LinkedField",
          "name": "core",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyCoreLoginPreferences",
              "kind": "LinkedField",
              "name": "login",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "enableEmail",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "enableTaxID",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "enableEnrollment",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "893a2fdce3f3fc58e666a553bdeedfbd";

export default node;
